import React from 'react';

function SubTitle(props) {
    return (<div className={'text-center'}>{props.subTitle}</div>)
}
export default SubTitle;